import { useContext } from "react"
import { QuestionnaireContext } from "../../context/QuestionnaireContext"
import type { QuestionProps } from "./Question"
import { Question } from "./Question"
import { enableWhenConditionsMet } from "./enableWhenConditionsMet"

export function GroupQuestion({ question, saveResponses, topLevel }: QuestionProps): JSX.Element {
  const questionnaireContext = useContext(QuestionnaireContext)
  if (!questionnaireContext) {
    throw new Error("GroupQuestion must be used within a QuestionnaireProvider")
  }
  const { responses } = questionnaireContext

  const questionIsInUse =
    question.enableWhen == null ? true : enableWhenConditionsMet(question.enableWhen ?? [], responses)

  if (topLevel && !questionIsInUse) return <h1>Question not in use</h1>

  return (
    <>
      {(question.item ?? []).map((groupedQuestion, index) => (
        <Question
          key={groupedQuestion.linkId}
          question={groupedQuestion}
          saveResponses={saveResponses}
          topLevel={index === 0}
        />
      ))}
    </>
  )
}
